module.exports = __webpack_public_path__ + "img/ico_1.da69bf68.png";